export const COMPLETABLE_TASK_FACET = 'completable';
